import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
/**
 * Created by AAravindan on 5/10/16.
 */

"use strict";

import { Stochastic } from "../momentum/Stochastic";
import { SMA } from "../moving_averages/SMA";
import { RSI } from "../oscillators/RSI";
export var StochasticRsiInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(StochasticRsiInput, _IndicatorInput);

  function StochasticRsiInput() {
    _classCallCheck(this, StochasticRsiInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(StochasticRsiInput).apply(this, arguments));
  }

  return StochasticRsiInput;
}(IndicatorInput);
export var StochasticRSIOutput = function StochasticRSIOutput() {
  _classCallCheck(this, StochasticRSIOutput);
};
export var StochasticRSI =
/*#__PURE__*/
function (_Indicator) {
  _inherits(StochasticRSI, _Indicator);

  function StochasticRSI(input) {
    var _this;

    _classCallCheck(this, StochasticRSI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StochasticRSI).call(this, input));
    var closes = input.values;
    var rsiPeriod = input.rsiPeriod;
    var stochasticPeriod = input.stochasticPeriod;
    var kPeriod = input.kPeriod;
    var dPeriod = input.dPeriod;
    var format = _this.format;
    _this.result = [];
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var index, rsi, stochastic, dSma, lastRSI, stochasticRSI, d, result, tick, stochasticInput;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              index = 1;
              rsi = new RSI({
                period: rsiPeriod,
                values: []
              });
              stochastic = new Stochastic({
                period: stochasticPeriod,
                high: [],
                low: [],
                close: [],
                signalPeriod: kPeriod
              });
              dSma = new SMA({
                period: dPeriod,
                values: [],
                format: function format(v) {
                  return v;
                }
              });
              _context.next = 6;
              return;

            case 6:
              tick = _context.sent;

            case 7:
              if (!true) {
                _context.next = 15;
                break;
              }

              lastRSI = rsi.nextValue(tick);

              if (lastRSI !== undefined) {
                stochasticInput = {
                  high: lastRSI,
                  low: lastRSI,
                  close: lastRSI
                };
                stochasticRSI = stochastic.nextValue(stochasticInput);

                if (stochasticRSI !== undefined && stochasticRSI.d !== undefined) {
                  d = dSma.nextValue(stochasticRSI.d);

                  if (d !== undefined) {
                    result = {
                      stochRSI: stochasticRSI.k,
                      k: stochasticRSI.d,
                      d: d
                    };
                  }
                }
              }

              _context.next = 12;
              return result;

            case 12:
              tick = _context.sent;
              _context.next = 7;
              break;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    closes.forEach(function (tick, index) {
      var result = _this.generator.next(tick);

      if (result.value !== undefined) {
        _this.result.push(result.value);
      }
    });
    return _this;
  }

  _createClass(StochasticRSI, [{
    key: "nextValue",
    value: function nextValue(input) {
      var nextResult = this.generator.next(input);

      if (nextResult.value !== undefined) {
        return nextResult.value;
      }
    }
  }]);

  return StochasticRSI;
}(Indicator);
StochasticRSI.calculate = stochasticrsi;
export function stochasticrsi(input) {
  Indicator.reverseInputs(input);
  var result = new StochasticRSI(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}